import { defineComponent } from "vue";
import orderService from "@/services/order.service";
import decimalService from "@/services/decimal.service";
import dateFormatService from "@/services/date-format.service";
import moment from "moment";
import { useToast } from "vue-toastification";
import VueCookie from "vue-cookie";

export default defineComponent({
   name: "customer-purchase-history-detail",
   setup() {
      const toast = useToast();
      return { toast };
   },
   filters: {
      date(val) {
         return val ? moment(val).format("YYYY-MM-DD") : "";
      },
   },
   data() {
      return {
         isGuest: false,
         order: [],
         add_on: [],
         order_item: [],
         quotation: [],
         quotation_package: [],
         payments: [],
         vehicle: [],
         insurance: [],
         summary: [],
         order_sum_insured_from: "",
         order_sum_insured_to: "",
         cover_type: "",
         showSendPolicyButton: false,
         showOrderCompletedButton: false,
         showOrderCancelledButton: false,
         showOrderPaymentAcceptedButton: false,
         showOrderPaymentRejectedButton: false,
         showOrderPaymentRefundedButton: false,
         showProcessingPolicyButton: false,
         showUpdateSumInsuredDate: false,
         showSendRoadTaxButton: false,
         showAddManagerNote: false,
      };
   },
   methods: {
      getOrderDetails() {
         const loader = this.$loading.show();
         const orderId = this.$route.params.orderId;
         const customerId = JSON.parse(VueCookie.get("user")).id_customer;
         return orderService
            .getOrderDetails(customerId, orderId)
            .then((result) => {
               this.order = Object.freeze(result.data);
               this.quotation = result.data._embedded.quotation;
               this.quotation_package = result.data._embedded.quotation_package;
               this.payments = Object.freeze(result.data._embedded.payments);
               this.insurance = result.data._embedded.insurance;
               this.add_on = result.data._embedded.add_on;
               this.cover_type = result.data._embedded.quotation_package.cover_type
                  ? result.data._embedded.quotation_package.cover_type
                  : result.data._embedded.quotation.cover_type;
               this.order_sum_insured_from = result.data._embedded.quotation.sum_insured_from;
               this.order_sum_insured_to = result.data._embedded.quotation.sum_insured_to;
               loader.hide();
            })
            .catch((error) => {
               loader.hide();
               console.error("error:", error.response.data.toString());
               this.toast.error(error.response.data.toString());
            });
      },
      formatDate(date: string) {
         return dateFormatService.formatDate(date);
      },
      formatDateTime(date: string) {
         return dateFormatService.formatDateTime(date);
      },
      formatDatePeriod(date: string) {
         return dateFormatService.formatDatePeriod(date);
      },
      convertTo2Decimal(number) {
         return decimalService.formatNumberTo2Decimal(number);
      },
   },
   mounted() {
      this.getOrderDetails();
   },
});
